import productsFieldsQuery from '../domain/types/graphql/fields/products'
import { recommendedFieldsQuery } from './recommendations'
import { gql } from './gql'

/**
 * "Opciones similares" — what to buy *instead of* this sku.
 *
 * Takes a list of skus because the field does: a product page asks about one,
 * but a cart could ask about every out-of-stock line in a single round trip.
 * It answers `SuggestedItemReturned`, so a proposed quantity rides along.
 */
export const GET_ALTERNATIVE_PRODUCTS = gql`
  query AlternativeProducts($storefrontName: String!, $sessionUid: ID!, $skus: [String!]!) {
    alternativeProducts(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      skus: $skus
    ) {
      ${recommendedFieldsQuery}
    }
  }
`

/**
 * "Se compran juntos" — what to buy *with* this sku. A different question from
 * `alternativeProducts`, and the reason both exist: an alternative replaces the
 * product, a companion adds to it.
 *
 * `skus` is `[String]!` here (nullable members) against `[String!]!` on
 * `alternativeProducts`. Ours are never null either way; the difference is
 * recorded so a copy-paste between the two documents does not fail validation
 * quietly at the first call.
 */
export const GET_FREQUENTLY_BOUGHT_TOGETHER = gql`
  query FrequentlyBoughtTogether(
    $storefrontName: String!
    $sessionUid: String!
    $skus: [String]!
    $limit: Int
  ) {
    frequentlyBoughtTogether(
      storefrontName: $storefrontName
      sessionUid: $sessionUid
      skus: $skus
      limit: $limit
    ) {
      ${productsFieldsQuery}
    }
  }
`

/**
 * The storefront's linked products — session-wide, not per-sku. It is the
 * fallback when a storefront has no alternatives model configured, since the
 * links are authored rather than computed.
 */
export const GET_LINKED_PRODUCTS = gql`
  query LinkedProducts($storefrontName: String!, $sessionUid: ID!) {
    linkedProducts(storefrontName: $storefrontName, sessionUid: $sessionUid) {
      ${productsFieldsQuery}
    }
  }
`
